import { FC } from "react"
import { getEncumbranceFill, getEncumbranceStyle } from "@/helpers/encumbrance"
import { formatWeightText } from "@/modals/constructor/inventory/InventoryModal/helpers"
import { IInventoryWeight } from "@/store/apis/inventoryAPI/inventory.types"
import styles from "./WeightBar.module.scss"

export const WeightBar: FC<{ weight: IInventoryWeight }> = ({ weight }) => (
  <div
    className={styles.WeightBar}
    style={getEncumbranceStyle(weight.loadRatio)}
  >
    <div
      className={styles.WeightBar_fill}
      style={{ width: `${getEncumbranceFill(weight.loadRatio) * 100}%` }}
    />
    <span className={styles.WeightBar_text}>{formatWeightText(weight)}</span>
  </div>
)
